/* The Versigent mark.
 *
 * Three strokes from the official logo package (versigent.com). The wordmark
 * is set in the fallback face: Aeonik is licensed, so it is not shipped.
 *
 * `tone` lets the same path serve the orange mark on a light surface and the
 * white one on the dark sign-in panel, without a second copy of the geometry
 * drifting out of step with this one.
 */

export function VersigentMark({
  size = 28,
  tone = 'brand',
}: {
  size?: number
  tone?: 'brand' | 'light' | 'current'
}) {
  const fill = tone === 'light' ? '#ffffff' : tone === 'current' ? 'currentColor' : 'var(--accent)'
  return (
    <svg viewBox="0 0 191 190" width={size} height={size} aria-hidden="true" role="presentation">
      <path
        d="M57.7058 70.6293C69.8627 83.0319 79.3746 97.9261 88.5794 112.333C97.0864 125.647 105.154 138.266 114.819 148.267C113.109 143.019 111.874 137.424 111.107 131.375C109.173 116.238 110.388 100.251 111.567 84.7718C113.856 54.712 115.852 24.2415 94.616 -0.00683594C60.6927 0.104523 30.9636 17.9567 14.2637 44.7315C30.6007 49.0049 44.8302 57.482 57.7058 70.6223V70.6293Z"
        fill={fill}
      />
      <path
        d="M95.0493 161.101C84.6581 149.902 76.3326 136.184 68.2722 122.912C52.64 97.1462 36.5193 71.2275 5.17119 63.7734C1.82143 73.4477 0 83.8389 0 94.6546C0 146.93 42.4931 189.309 94.9098 189.309C106.62 189.309 117.828 187.187 128.184 183.324C115.72 179.057 105.078 171.896 95.0563 161.101H95.0493Z"
        fill={fill}
      />
      <path
        d="M123.146 4.19727C128.324 13.7045 131.785 24.2697 133.628 36.1085C136.293 53.2507 135.358 70.8802 134.451 87.9389C133.558 104.879 132.706 120.873 135.365 135.447C137.815 148.873 143.077 159.556 151.402 167.992C151.549 168.013 151.688 168.041 151.835 168.054V168.416C152.24 168.82 152.651 169.217 153.07 169.607C175.541 152.297 190.015 125.161 190.015 94.6552C190.015 52.1093 161.87 16.1266 123.139 4.19727H123.146Z"
        fill={fill}
      />
    </svg>
  )
}

/** Mark plus wordmark, for the sidebar and the sign-in panel. */
export function VersigentLogo({
  size = 28,
  tone = 'brand',
  subtitle = 'Capacity Study',
}: {
  size?: number
  tone?: 'brand' | 'light'
  subtitle?: string | null
}) {
  return (
    <div style={{ display: 'flex', gap: 11, alignItems: 'center' }}>
      <VersigentMark size={size} tone={tone} />
      <div>
        <div
          style={{
            fontWeight: 700,
            fontSize: size * 0.56,
            letterSpacing: '-0.02em',
            color: tone === 'light' ? '#fff' : 'var(--text-primary)',
            lineHeight: 1.1,
          }}
        >
          Versigent
        </div>
        {subtitle && (
          <div
            style={{
              fontSize: Math.max(10, size * 0.38),
              color: tone === 'light' ? 'rgba(255,255,255,.72)' : 'var(--text-secondary)',
              lineHeight: 1.2,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
    </div>
  )
}
